import { memo } from 'react';
import { Box, Skeleton } from '@mui/material';
import { getTableColumns, getTableGrid, SKELETON_WIDTHS } from './apiServiceTableLayout';

function SkeletonRow({ gridCols, columnCount, rowIndex }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: gridCols,
        px: 1.5,
        py: 1.1,
        alignItems: 'center',
        borderTop: '1px solid #e1e5ec',
        bgcolor: rowIndex % 2 === 0 ? 'white' : '#f9fafc',
      }}
    >
      {Array.from({ length: columnCount }, (_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          height={20}
          width={SKELETON_WIDTHS[i] ?? '70%'}
          sx={{ bgcolor: 'grey.200', maxWidth: '100%' }}
        />
      ))}
    </Box>
  );
}

function ApiServiceTableSkeletonBody({ showAccountCol, rowCount = 10 }) {
  const { gridCols } = getTableGrid(showAccountCol);
  const columnCount = getTableColumns(showAccountCol).length;
  const safeCount = Math.max(1, Math.min(rowCount, 100));

  return (
    <>
      {Array.from({ length: safeCount }, (_, i) => (
        <SkeletonRow key={i} gridCols={gridCols} columnCount={columnCount} rowIndex={i} />
      ))}
    </>
  );
}

export default memo(ApiServiceTableSkeletonBody);
